import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import {
    Box,
    Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import primitiveMessages from '../messages/primitiveMessages';
import { useFlow } from '../../routing/FlowProvider';
import { scrollToElement } from '../../utils/productDetailsPageUtils';

const BackButton = ({
    intl,
    stepName,
    className,
    ariaLabel
}) => {
    const { goToPreviousStep } = useFlow();
    const handleFocus = () => {
        setTimeout(() => { scrollToElement('back-button',); }, 10);
    };
    return (
        <Box className={classNames('back-button-container', className)}>
            <Button
                id='back-button'
                disableFocusRipple
                className='back-button text-button'
                onClick={() => {
                    goToPreviousStep(stepName, { shouldPushHistory: false });
                }}
                onFocus={handleFocus}
                aria-label={intl.formatMessage(ariaLabel)}
            >
                <ArrowBackIcon className='back-button-arrow-icon' />
                <span className='back-button-text'>
                    {intl.formatMessage(primitiveMessages.backButtonText)}
                </span>
            </Button>
        </Box>
    );
};

BackButton.defaultProps = {
    className: '',
    ariaLabel: {
        id: 'primitive.primitiveMessages.backButtonText',
        description: 'Back button text',
        defaultMessage: 'Back'
    }
};

BackButton.propTypes = {
    
    className: PropTypes.string,
    stepName: PropTypes.string.isRequired,
    
    intl: intlShape.isRequired,
    ariaLabel: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
        description: PropTypes.string
    })

};

export default injectIntl(BackButton);
